import { render, staticRenderFns } from "./wall.vue?vue&type=template&id=45bf7af2&"
import script from "./wall.vue?vue&type=script&lang=js&"
export * from "./wall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports